module.exports = __webpack_public_path__ + "media/images/SpecialBanner-fdaf8a001493aba6c3b86fcedb70f971.png";